<template>
  <div class="modal_card reverse">
    <div class="modal_form">
      <i @click="$emit('close-modal')" class="icon-close"></i>
      <h1>Добавление пользователей</h1>
      <form @submit.prevent="submitUser">
        <b-field label="Роль:" type="is-info" class="modal_select big_field has_icon grey">
          <b-select
            @input="handleChange"
            placeholder="Роль"
            required
            icon="mdi mdi-account-tie"
            v-model="modalInfo.role"
          >
            <option :value="1">Администратор</option>
            <option :value="2">Студент</option>
            <option :value="3">Методист</option>
            <option :value="4">Руководитель</option>
            <option :value="5">Системный администратор</option>
          </b-select>
        </b-field>
        <b-collapse
          v-for="(user, i) in newUsers"
          :key="i"
          :open="isOpen"
          aria-id="modal-users-list"
          class="modal-users-list"
        >
          <div @click="open" class="list_header users active" slot="trigger" aria-controls="modal-users-list">
            <span class="left"> <i class="icon-button-arrow"></i>{{ modalInfo.rolename }} - {{ i + 1 }} </span>
            <span class="delete-button" @click="$emit('remove-user', i)">
              <i class="mdi mdi-delete"></i>
            </span>
          </div>
          <b-field
            label="Имя:"
            type="is-info"
            class="left_input has_icon"
            :message="errors.first('name' + i)"
            :class="errors.first('name' + i) ? 'error' : ''"
          >
            <b-input
              placeholder="Имя"
              v-model="user.name"
              :name="'name' + i"
              icon="mdi mdi-account"
              v-validate="{ required: true, min: 2, max: 20 }"
            ></b-input>
          </b-field>
          <b-field
            label="Фамилия:"
            type="is-info"
            class="right_input has_icon"
            :message="errors.first('surname' + i)"
            :class="errors.first('surname' + i) ? 'error' : ''"
          >
            <b-input
              placeholder="Фамилия"
              v-model="user.surname"
              :name="'surname' + i"
              icon="mdi mdi-account"
              v-validate="{ required: true, min: 2, max: 20 }"
            ></b-input>
          </b-field>
          <b-field
            label="Отчество:"
            type="is-info"
            class="left_input has_icon"
            :message="errors.first('patronymic' + i)"
            :class="errors.first('patronymic' + i) ? 'error' : ''"
          >
            <b-input
              placeholder="Отчество"
              v-model="user.patronymic"
              :name="'patronymic' + i"
              icon="mdi mdi-account"
              v-validate="{ required: true, min: 2 }"
            ></b-input>
          </b-field>
          <b-field
            label="Должность:"
            type="is-info"
            class="right_input has_icon"
            :message="errors.first('position' + i)"
            :class="errors.first('position' + i) ? 'error' : ''"
          >
            <b-input
              placeholder="Должность"
              v-model="user.position"
              :name="'position' + i"
              icon="mdi mdi-account-tie"
              v-validate="{ required: true, min: 2 }"
            ></b-input>
          </b-field>
          <b-field
            v-if="modalInfo.role !== 1 && modalInfo.role !== 3"
            label="Филиал:"
            type="is-info"
            class="modal_select big_field has_icon"
          >
            <b-select
              placeholder="Филиал"
              required
              icon="mdi mdi-folder"
              v-model="user.branch_id"
            >
              <option v-for="(branch, j) in branchesList" :key="j" :value="branch.id">{{ branch.name }}</option>
            </b-select>
          </b-field>
          <b-field
            v-if="modalInfo.role != 2"
            label="Email:"
            type="is-info"
            class="big_field has_icon"
            :message="errors.first('email' + i)"
            :class="errors.first('email' + i) ? 'error' : ''"
          >
            <b-input
              placeholder="Email"
              v-model="user.email"
              :name="'email' + i"
              icon="mdi mdi-email"
              type="text"
              v-validate="{ required: true, email: true, regex: /^[^а-яА-Я]+@([^а-яА-Я]+\.)+[^а-яА-Я]{2,}$/ }"
            ></b-input>
          </b-field>
        </b-collapse>
        <div class="add-user" @click="addUser">Добавить нового пользователя</div>
        <button class="add_user_button modal_button left_button" :disabled="errors.items.length > 0">
          Добавить
        </button>
        <button @click="$emit('close-modal')" class="close_button modal_button right_button">Отмена</button>
      </form>
    </div>
  </div>
</template>

<script>
// import loadingSelect from '@/components/ui/loadingSelect'

export default {
  props: {
    modalInfo: {
      default: () => {},
      type: Object
    },
    newUsers: {
      default: () => [],
      type: Array
    }
  },
  data() {
    return {
      isOpen: true,
      isLoading: false,
    }
  },
  methods: {
    handleChange(val) {
      switch (val) {
        case 1:
          this.modalInfo.rolename = 'Администратор'
          break
        case 2:
          this.modalInfo.rolename = 'Студент'
          break
        case 3:
          this.modalInfo.rolename = 'Методист'
          break
        case 4:
          this.modalInfo.rolename = 'Руководитель'
          break
        case 5:
          this.modalInfo.rolename = 'Системный администратор'
          break
      }
      this.$emit('change')
      this.updateDict()
    },
    submitUser() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit('create-user')
        }
      })
    },
    open(e) {
      if (e.currentTarget.classList.contains('active')) {
        e.currentTarget.classList.remove('active')
      } else {
        e.currentTarget.classList.add('active')
      }
    },
    updateDict() {
      let dict = {
        custom: {}
      }
      for (let i = 0; i < this.newUsers.length; i++) {
        dict.custom['name' + i] = {
          required: 'Поле не заполнено',
          min: 'Слишком короткое значение',
          max: 'Слишком длинное значение'
        }
        dict.custom['surname' + i] = {
          required: 'Поле не заполнено',
          min: 'Слишком короткое значение',
          max: 'Слишком длинное значение'
        }
        dict.custom['patronymic' + i] = {
          required: 'Поле не заполнено',
          min: 'Слишком короткое значение'
        }
        dict.custom['position' + i] = {
          required: 'Поле не заполнено',
          min: 'Слишком короткое значение'
        }
        dict.custom['email' + i] = {
          required: 'Поле не заполнено',
          email: 'Неверный формат',
          regex: 'Логин должен состоять из латинских букв'
        }
      }
      this.$validator.localize('ru', dict)
    },
    addUser() {
      this.$emit('add-user')
      this.updateDict()
    }
  },
  created() {
    this.updateDict()
  },
  computed: {
    branchesList() {
      return this.$store.state.right.rightBranchesList
    }
  }
}
</script>
